module.exports = function isSmallScreen() {
  return window.innerWidth < 600;
}


// WEBPACK FOOTER //
// ./src/lib/isSmallScreen.js